import { SupplyType } from "../components/EditionSelector";

export const getSupplyType = (supply: number): SupplyType => {
  if (supply === 0) {
    return SupplyType.Unlimited;
  }

  return supply > 1 ? SupplyType.Limited : SupplyType.Single;
};
